<template>
  <div class="wrapper">
    <base-bread-crumb :currBreadCrumb="currBreadCrumb"></base-bread-crumb>
    <div class="ccui-app-container-detail">
      <div class="ccui-app-container">
        <div class="notice-title">{{ pageData.faqName }}</div>
        <div class="color-1">
          <span class="pr20">来源：新增</span>
          <span class="pr20">作者：{{ pageData.publishUser }}</span>
          <span>发布日期：{{ pageData.publishTime }}</span>
        </div>
        <el-divider></el-divider>
        <div v-html="pageData.textContent"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getFaqProblemById } from "@/app/shop/api/shopping";
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb";
export default {
  name: "questionOrManualDetail",
  components: {
    baseBreadCrumb
  },
  data() {
    return {
      pageData: {},
      currBreadCrumb: [],
      type: ""
    };
  },
  deactivated() {
    this.currBreadCrumb = [];
  },
  activated() {
    this.type = this.$route.query.type;
    if (this.type === "1") {
      this.currBreadCrumb.push({
        title: "采购方操作指南",
        path: "/operationManual"
      });
    } else if (this.type === "2") {
      this.currBreadCrumb.push({
        title: "业务流程及常见问题",
        path: "/question"
      });
    }
    this.init();
  },
  computed: {},
  methods: {
    init() {
      getFaqProblemById({
        faqId: this.$route.query.id,
        isShowPageLoading: true
      }).then(res => {
        if (res.data.code === "0") {
          this.pageData = res.data.data.faqProblemBO;
          this.currBreadCrumb.push({ title: this.pageData.faqName });
          // this.$set(this.currBreadCrumb, 1, {title: this.pageData.faqName});
        }
      });
    }
  }
};
</script>

<style scoped></style>
